// Angular
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

// Afidium
import { BookingInTicketingReportComponent } from './booking-in-ticketing-report.component';
import { GuardService } from 'app/shared/services/guard/guard.service';

@NgModule({
    imports: [
        RouterModule.forChild([
            {
                path: '',
                pathMatch: 'full',
                component: BookingInTicketingReportComponent,
                canActivate: [GuardService],
                data: { permissionPath: 'sasha.booking.ticketingReport.use', redirectTo: '/sasha/home' },
            },
        ]),
    ],
    exports: [
        RouterModule,
    ],
})
export class BookingInTicketingReportRouting { }
